import * as XLSX from 'xlsx';
import type { LeadExportRow } from '../services/leads.service';

const EXPORT_COLUMNS: { header: string; key: keyof LeadExportRow; width: number }[] = [
  { header: 'Lead ID', key: 'leadId', width: 28 },
  { header: 'Full Name', key: 'fullName', width: 24 },
  { header: 'Email', key: 'email', width: 28 },
  { header: 'Phone', key: 'phoneNumber', width: 16 },
  { header: 'WhatsApp', key: 'whatsappNumber', width: 16 },
  { header: 'Preferred Destination', key: 'preferredDestination', width: 22 },
  { header: 'Stream', key: 'stream', width: 14 },
  { header: 'Section', key: 'section', width: 12 },
  { header: 'Lead Source', key: 'leadSource', width: 14 },
  { header: 'Status', key: 'status', width: 14 },
  { header: 'Assigned To', key: 'assignedTo', width: 22 },
  { header: 'City', key: 'city', width: 14 },
  { header: 'State', key: 'state', width: 14 },
  { header: 'Country', key: 'country', width: 14 },
  { header: 'Qualification', key: 'qualification', width: 18 },
  { header: 'Percentage / CGPA', key: 'percentageOrCgpa', width: 16 },
  { header: 'Passing Year', key: 'passingYear', width: 12 },
  { header: 'Institution', key: 'institution', width: 22 },
  { header: 'Preferred Course', key: 'preferredCourse', width: 20 },
  { header: 'Intake', key: 'intake', width: 12 },
  { header: 'Budget Range', key: 'budgetRange', width: 16 },
  { header: 'Passport Status', key: 'passportStatus', width: 16 },
  { header: 'English Test Status', key: 'englishTestStatus', width: 18 },
  { header: 'Loan Required', key: 'loanRequired', width: 14 },
  { header: 'Message', key: 'message', width: 32 },
  { header: 'Created At', key: 'createdAt', width: 22 },
];

export function downloadLeadsExcel(rows: LeadExportRow[], filename = 'leads-export.xlsx'): void {
  if (typeof document === 'undefined') return;

  const header = EXPORT_COLUMNS.map((column) => column.header);
  const data = rows.map((row) => EXPORT_COLUMNS.map((column) => row[column.key] ?? ''));

  const worksheet = XLSX.utils.aoa_to_sheet([header, ...data]);
  worksheet['!cols'] = EXPORT_COLUMNS.map((column) => ({ wch: column.width }));

  const workbook = XLSX.utils.book_new();
  XLSX.utils.book_append_sheet(workbook, worksheet, 'Leads');
  XLSX.writeFile(workbook, filename);
}
